import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  inject,
  signal,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { SkeletonModule } from 'primeng/skeleton';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, filter, finalize, of, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/features/auth/services/auth.service';
import { Notification } from 'app/features/user/models/notifications.model';
import { MessagesService } from 'app/features/user/services/messages.service';
import { Message } from 'app/features/user/models/messages.model';
import { SocketService } from 'app/features/user/services/socket.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-navbar-messages',
  standalone: true,
  imports: [DatePipe, SkeletonModule],
  templateUrl: './navbar-messages.component.html',
  styleUrl: './navbar-messages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
})
export class NavbarMessagesComponent {
  private messageService = inject(MessagesService);
  private auth = inject(AuthService);
  private router = inject(Router);
  private toaster = inject(ToastrService);
  private destroyRef = inject(DestroyRef);
  private el = inject(ElementRef);

  isOpen = signal(false);
  isOpenMessage = signal(false);
  loading = signal(false);
  messages = signal<Message[]>([]);

  socketService = inject(SocketService);
  private viewed = signal(false);
  user = computed(() => this.auth.currentUserSignal()?.user);
  hasUnviewedMessages = signal(false);
  isChatPage = signal(false);
  constructor() {
    // Initial value

    this.isChatPage.set(this.router.url.includes('/chats'));

    // Update whenever navigation changes
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event) => {
        this.isChatPage.set(event.urlAfterRedirects.includes('/chats'));
      });

    this.socketService.connect(localStorage.getItem('ShuwierToken') || '');
    this.socketService.on<any>('room:new-message').subscribe((message) => {
      if (!this.isOpen()) {
        this.hasUnviewedMessages.set(true);
      } else {
        this.loadMessages();
      }
    });
  }

  onDocumentClick(event: Event): void {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }

  onBellClick(event: Event): void {
    // If current URL contains /chats, do not open messages dropdown
    if (this.router.url.includes('/chats')) {
      return;
    }

    if (this.isOpen()) {
      this.isOpen.set(false);
    } else {
      this.isOpen.set(true);
    }

    if (this.hasUnviewedMessages()) {
      this.hasUnviewedMessages.set(false);
    }

    this.loadMessages();
  }

  onPanelClick(event: Event): void {
    event.stopPropagation();
  }

  onItemClick(notification: Message): void {
    console.log(notification.id);

    this.router.navigate(['/chats'], {
      state: { id: notification.id },
    });
    this.isOpen.set(false);
  }

  onNavigateTomessagesPage(): void {
    this.router.navigate(['/chats']);
    this.isOpen.set(false);
  }

  hasData(notification: Message): boolean {
    return !!notification?.type && !!notification.data?.id;
  }
  timeAgo = (date: string) => {
    const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
    const intervals: any = { y: 31536000, mo: 2592000, w: 604800, d: 86400, h: 3600, m: 60, s: 1 };
    const key = Object.keys(intervals).find((k) => seconds >= intervals[k]) || 's';
    return `${Math.floor(seconds / intervals[key])}${key} ago`;
  };
  loadMessages(): void {
    this.loading.set(true);
    this.messageService
      .getActiveMessages()
      .pipe(
        tap(() => this.loading.set(true)),
        catchError(() => of(null)),
        finalize(() => this.loading.set(false)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((res: any) => {
        console.log(this.user());
        console.log(res);

        if (res) {
          this.messages.set(
            res.data.map((item: any) => ({
              ...item,
              members: item.members.filter((member: any) => member.userId !== this.user().id),
            }))
          );
        }
      });
  }
}
